import O1HD, { services } from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import CharadeLevelConfig, { CharadeLevelInterface } from "../../Game/Config/CharadeLevelConfig";
import NormalGameManager from "../manager/NormalGameManager";
import NormalLevelBase from "../prefab/thruTime/common/LevelBase";
import Level_Charade_ChatItem from "./Level_Charade_chatItem";
import Level_Charade_selectItem from "./Level_Charade_selectItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Level_Charade extends cc.Component {

    @property({type:cc.Node,displayName:"selectContent"})
    selectContent:cc.Node = null;

    @property({type:cc.ScrollView,displayName:""})
    dialogScollView:cc.ScrollView = null;

    @property({type:cc.Node,displayName:"dialogContent"})
    dialogContent:cc.Node = null;

    chatItem:cc.Node = null;

    currentChatItem:Level_Charade_ChatItem = null;

    @property()
    BundleName:string = "";

    currentIndex:number = 0;

    @property()
    levelNum:number = 0;

    levelData:CharadeLevelInterface = null;

    @property({type:cc.Node,displayName:"左边item"})
    leftItem:cc.Node = null;

    @property({type:cc.Node,displayName:"右边item"})
    rightItem:cc.Node = null;

    @property({type:cc.Node,displayName:"选择节点"})
    selectNode:cc.Node = null;

    currentSelectStr:string = "";

    currentSelectNodes:cc.Node[] = [];

    @property({type:cc.Node,tooltip:"提示视频图标"})
    videoNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示页面"})
    hintNode:cc.Node = null;

    goTips:boolean = false;

    @property()
    protected levelTime : number = 120;

    @property({type:cc.Label,displayName:"计时label"})
    protected timeLabel : cc.Label = null;
    protected readonly timeSpace:number = 1;

    timeIsStop:boolean = true;
    
    onLoad(){
        this.levelData = CharadeLevelConfig()[this.levelNum];
        this.currentSelectStr = this.levelData.levelSelectFonts;
        this.timeLabel.string = data_control.getTimeFormatClock(this.levelTime);
        this.loadOneItem();
        this.loadInitSelectNode();
        this.timeLabel.node.parent.active= false;
        if(services().ossSrv.getPlatform() == "h5"){
            this.timeLabel.node.parent.active= false;
            return;
        }
        this.refrenshHintBtn();
        // this.schedule(this.TimeUpdate,this.timeSpace);
        // O1HD.on("level_add_time",this.addTime.bind(this),this);
        // O1HD.emit("ingame-show-add-time-btn");
    }

    addTime(){
        this.levelTime += 30;
   }

   TimeUpdate(){
    // if(this.pause){
    //     return;
    // }

    if(this.timeIsStop){
        return;
    }

    this.levelTime = Math.max(0,this.levelTime-1);
    if(this.levelTime<10){
        // O1HD.getManagers().soundMgr.playSound("mainSound/daojishi");
    }
    this.timeLabel.string = data_control.getTimeFormatClock(this.levelTime);
    if(this.levelTime == 0){
        //TODO 失败
        this.unschedule(this.TimeUpdate);
        this.timeIsStop = true;
    }
}

    protected start(): void {
        O1HD.getModules().uiControlModule.hideLoading();
    }

    loadInitSelectNode(){
        let str = this.currentSelectStr.substring(0,15);
        this.currentSelectStr = this.currentSelectStr.substring(15);
        for(let i = 0; i < str.length; i++){
            let s = str[i];
            let node = cc.instantiate(this.selectNode);
            node.y = 0;
            let ns = node.getComponent(Level_Charade_selectItem);
            ns.setData(s,this);
            this.selectContent.addChild(node);
        }
    }

    loadOneItem(){
        let data = this.levelData.levelDatas[this.currentIndex];
        if(!data){
            // 胜利
            if(NormalGameManager._instance.getGameData().isFirstBreakCode){
                O1HD.getServices().userSrv.setCoins(1000000,true,this.node);
                NormalGameManager._instance.setGameData({isFirstBreakCode:false});
            }
            this.unschedule(this.TimeUpdate);
            this.timeIsStop = true;
            this.closeThis();
            return;
        }
        let rotation = data.rotation;
        let node :cc.Node = null;
        switch(rotation){
            case 0:{
                // 生成一个左边item
                node = cc.instantiate(this.leftItem);
                break;
            }
            case 1:{
                // 生成一个右边Item
                node = cc.instantiate(this.rightItem);
                break;
            }
        }
        if(node){
            let ns = node.getComponent(Level_Charade_ChatItem);
            ns.setDate(data,this,rotation);
            this.currentChatItem = ns;
            this.dialogContent.addChild(node);
            this.dialogScollView.scrollToBottom(0.1);
        }
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getManagers().soundMgr.playVibrate();
        if(this.currentChatItem){
            let isTrue = this.currentChatItem.splitOneAnswer();
            if(isTrue){
                this.spliceOneAnswer();
            }
        }
    }

    spliceOneAnswer(){
        let node = this.currentSelectNodes.pop();
        if(node){
            node.getComponent(Level_Charade_selectItem).init();
        }
    }

    spliceAllAnswer(){
        for(let i =0;i<this.currentSelectNodes.length;i++){
            let node = this.currentSelectNodes[i];
            node.getComponent(Level_Charade_selectItem).init();
        }
        this.currentSelectNodes = [];
    }

    addOneAnswer(str:string,node:cc.Node){
        if(this.timeIsStop&&services().ossSrv.getPlatform() != "h5"){
            this.timeIsStop = false;
        }
        if(this.currentChatItem){
            let isTrue = this.currentChatItem.addOneAnswer(str);
            if(isTrue){
                this.currentSelectNodes.push(node);
            }
            return isTrue;
        }
        return false;
    }

    onBtnCommit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getManagers().soundMgr.playVibrate();
        if(this.currentChatItem){
            let isTrue:boolean = this.currentChatItem.checkAnswerIsVaild();
            if(isTrue){
                this.currentIndex++;
                this.loadOneItem();
                this.CaretFont();
                // O1HD.getManagers().soundMgr.playSound("mainSound/hcy1");
            }else{
                // 错误
                this.currentChatItem.splitAllAnswer();
                this.spliceAllAnswer();
                // O1HD.getManagers().soundMgr.playSound("mainSound/error");
            }
        }
    }

    CaretFont(){
        for(let i = 0;i<this.currentSelectNodes.length;i++){
            let node = this.currentSelectNodes[i];
            let str = this.currentSelectStr[i];
            if(str){
                node.getComponent(Level_Charade_selectItem).setData(str,this);
            }
        }
        this.currentSelectStr = this.currentSelectStr.substring(this.currentSelectNodes.length);
        this.currentSelectNodes = [];
    }

    onBtnHint(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.goTips){
            this.hintNode.active = true;
        }else{
            O1HD.getServices().miniGameSrv.getAppApiInstance().loadAndShowVideoAd(()=>{
                this.goTips = true;
                this.hintNode.active = true;
                this.refrenshHintBtn();
            },()=>{

            },null,"破解暗语看视频获得提示")
        }
    }

    onBtnCloseHint(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.hintNode.active = false;
    }

    onBtnCloseThis(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

    refrenshHintBtn(){
        this.videoNode.active = !this.goTips;
    }

}
